











import DealerSearchLayout from './DealerSearchLayout.vue';
import SearchForm from './SearchForm.vue';
import Map from './Map.vue';
import State from '@/classes/state';

export default {
    name: 'DealerSearch',
    components: {
        DealerSearchLayout,
        SearchForm,
        Map,
    },
    data() {
        const state: State = this.$store.state;

        return {
            config: state.config,
            isInitialized: false,
        };
    },
    computed: {
        showMap(): boolean {
            return (this.$store.state as State).showMap;
        },
    },
    methods: {
        async init() {
            await Promise.all([
                this.loadGoogleMapsApi(),
                this.loadDealerSearchModule(),
            ]);

            this.isInitialized = true;
        },
        async loadGoogleMapsApi(): Promise<void> {
            return new Promise((resolve, reject) => {
                const { clientId } = this.config.map.providers.google;

                if (window.google && window.google.maps) {
                    // google maps API already available
                    resolve();
                    return;
                }

                if (!clientId) {
                    reject('Google Maps ClientId missing');
                    return;
                }

                const script = document.createElement('script');
                script.src = `//maps.googleapis.com/maps/api/js?libraries=places&client=${clientId}`;
                script.onload = () => {
                    resolve();
                };
                document.head.appendChild(script);
            });
        },
        loadDealerSearchModule() {
            return Miele.ModuleLoader.importModule("modules/applications/dealer-search");
        },
    },
    mounted() {
        this.init();

    }
};
